export const sagaList = name => {
  return `SAGA_FETCH_${name.toUpperCase()}`;
};

export const sagaListSuccess = name => {
  return `SAGA_FETCH_${name.toUpperCase()}_SUCCESS`;
};

export const sagaSearch = name => {
  return `SAGA_SEARCH_${name.toUpperCase()}`;
};

export const sagaSearchSuccess = name => {
  return `SAGA_SEARCH_${name.toUpperCase()}_SUCCESS`;
};

export const sagaSearchFailed = name => {
  return `SAGA_SEARCH_${name.toUpperCase()}_FAILURE`;
};

export const sagaOne = name => {
  return `SAGA_FETCH_${name.toUpperCase()}`;
};

export const sagaOneSuccess = name => {
  return `SAGA_FETCH_${name.toUpperCase()}_SUCCESS`;
};

export const sagaCreate = name => {
  return `SAGA_CREATE_${name.toUpperCase()}`;
};

export const sagaCreateSuccess = name => {
  return `SAGA_CREATE_${name.toUpperCase()}_SUCCESS`;
};

export const sagaUpdate = name => {
  return `SAGA_UPDATE_${name.toUpperCase()}`;
};

export const sagaUpdateSuccess = name => {
  return `SAGA_UPDATE_${name.toUpperCase()}_SUCCESS`;
};

export const sagaDelete = name => {
  return `SAGA_DELETE_${name.toUpperCase()}`;
};

export const sagaDeleteSuccess = name => {
  return `SAGA_DELETE_${name.toUpperCase()}_SUCCESS`;
};



// WEBPACK FOOTER //
// ./src/actions/ActionTypes.js